/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import PropTypes from 'prop-types';
import React from 'react';

import { StringHelper } from 'sarsaparilla';

const propTypes = {
    name: PropTypes.string,
};

export function LocationName(props) {
    if (!props.name) {
        return null;
    }
    const name = StringHelper.toTitleCase(props.name);

    return <div className={props.className}>{name}</div>;
}

LocationName.propTypes = propTypes;

export default LocationName;
